module.exports = __webpack_public_path__ + "media/images/flags/1x1/bel-3986e83e5f419ae93d97bb3a77f89ba4.svg";